import { Quote } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const STORIES = [
  {
    id: "georgia",
    text: "Поехал в Грузию и вдруг понял: не могу зайти в свой банк. Нужно было перевести себе деньги на виртуальную карту, чтобы не остаться без средств, а банк не работает. Я уже начал паниковать, пока не вспомнил включить в НОРЕ российский сервер. Банк заработал. Фух!",
    tag: "Грузия · банк и деньги",
  },
  {
    id: "italy",
    text: "Отец живет в Италии уже 40 лет, он пожилой фермер. Мы всегда созванивались, а тут вдруг не получается — ни прилететь, ни дозвониться. Спасибо НОРЕ — можем продолжать общаться в WhatsApp. Связь не потеряна.",
    tag: "Италия · семья",
  },
  {
    id: "home",
    text: "Изучаю селекцию арбузов — без Ютуба было бы не разобраться, как вырастить моих полосатиков. Обидно, когда вас ограничивают в знаниях. НОРА меня просто спасает: благодаря ей вырастила своего сахарного малыша.",
    tag: "Дома · хобби",
  },
  {
    id: "designer",
    text: "Я дизайнер и каждый день работаю с нейросетями. И вдруг половина моих инструментов просто перестала открываться — а у меня дедлайн, клиент ждет макеты. Включила НОРУ — и Midjourney с ChatGPT снова на месте. Сдала проект вовремя, клиент в восторге.",
    tag: "Дома · работа с ИИ",
  },
];

export default function Stories() {
  return (
    <section id="stories" className="py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Chapter n="03">Живые истории</Chapter>
        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {STORIES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.12}>
              <figure
                data-testid={`story-card-${s.id}`}
                className="flex h-full flex-col rounded-[2rem] border border-nora-ink/5 bg-nora-surface p-8 shadow-sm transition-transform duration-300 hover:-translate-y-2"
              >
                <Quote className="h-7 w-7 text-nora-pink" fill="currentColor" />
                <blockquote className="mt-4 flex-1 leading-relaxed text-nora-ink/80">
                  «{s.text}»
                </blockquote>
                <figcaption className="mt-6">
                  <span className="inline-block rounded-full bg-nora-pink/10 px-4 py-1.5 text-sm font-semibold text-nora-pink">
                    {s.tag}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
